"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3829],{

/***/ 761203:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ LoginUserIcon; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);

var LoginUserIcon = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: props.width || "16",
        height: props.height || "18.963",
        viewBox: "0 0 24.02 24.49",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
            id: "user-10",
            transform: "translate(-23.819 -26.9)",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    id: "Path_132898",
                    "data-name": "Path 132898",
                    d: "M54.666,33.833a6.833,6.833,0,1,0-6.833,6.833A6.834,6.834,0,0,0,54.666,33.833Zm-11.883,0a5.05,5.05,0,1,1,5.05,5.05A5.046,5.046,0,0,1,42.782,33.833Z",
                    transform: "translate(-12.005)",
                    stroke: "#000",
                    strokeWidth: "0.2",
                    fill: props.color
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    id: "Path_132899",
                    "data-name": "Path 132899",
                    d: "M24.39,89.081a.838.838,0,0,0,.446.119.861.861,0,0,0,.772-.446,11.756,11.756,0,0,1,20.469,0,.892.892,0,0,0,1.545-.891,13.566,13.566,0,0,0-23.588,0A.893.893,0,0,0,24.39,89.081Z",
                    transform: "translate(0 -37.958)",
                    stroke: "#000",
                    strokeWidth: "0.2",
                    fill: props.color
                })
            ]
        })
    });
};


/***/ }),

/***/ 644992:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ ShoppingBag; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);

var ShoppingBag = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: props.width || "16",
        height: props.height || "18.963",
        viewBox: "0 0 16 18.963",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
            id: "shopping-bag-6",
            transform: "translate(-40)",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                id: "Path_132897",
                "data-name": "Path 132897",
                d: "M55.259,4.444H53a5.037,5.037,0,0,0-10,0H40.741A.741.741,0,0,0,40,5.185V18.222a.741.741,0,0,0,.741.741H55.259A.741.741,0,0,0,56,18.222V5.185A.741.741,0,0,0,55.259,4.444ZM48,1.481a3.561,3.561,0,0,1,3.506,2.963H44.494A3.561,3.561,0,0,1,48,1.481Zm6.519,16H41.481V5.926H54.519Z",
                fill: props.color
            })
        })
    });
};


/***/ }),

/***/ 193829:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(626042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(269396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(811163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _redux_actions__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(792516);
/* harmony import */ var _redux_actions__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(117321);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(667294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(225617);
/* harmony import */ var _utils_routes__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(540190);
/* harmony import */ var _components_Common_ReactHamburger__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70440);
/* harmony import */ var _components_LoginAndDropdownComponent__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(629492);
/* harmony import */ var _utils_deviceWidth__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(186812);
/* harmony import */ var _utils_checkClientDeviceType__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(313508);
/* harmony import */ var _utils_getContrastingColor__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(833104);
/* harmony import */ var _utils_getCustomHeaderTextColor__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(956494);
/* harmony import */ var _utils_invertAngleRightIconColor__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(636874);
/* harmony import */ var _utils_showMegaMenu__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(36408);
/* harmony import */ var _utils_getStoreType__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(66871);
/* harmony import */ var _CommonHeaderIcons__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(335022);
/* harmony import */ var _assets_svgExports_LoginUserIcon__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(761203);
/* harmony import */ var _assets_svgExports_ShoppingBag__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(644992);
/* harmony import */ var _assets_svgExports_HeaderInfoIcon__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(337247);
/* harmony import */ var _assets_svgExports_SearchIcon__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(350127);
/* harmony import */ var _assets_svgExports_HeaderHome__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(452882);
/* harmony import */ var _StoreNameComponent__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(644128);
/* harmony import */ var _ShopComponent__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(811525);
/* harmony import */ var _CommonNavbarText_CommonNavbarText__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(932461);
/* harmony import */ var _hooks_useSaveHeaderHeight__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(953395);
/* harmony import */ var _HeaderUtils_useIsShopDropDownEnable__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(700634);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(913886);
/* harmony import */ var _redux_ssrStore__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(326706);
/* harmony import */ var _utils_logoAndNameHelpers__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(273494);
/* harmony import */ var _utils_getActualOrDsStoreLogo__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(168491);
/* harmony import */ var _Drawer_MenuDrawerMobile__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(586361);
/* harmony import */ var _Drawer_MegaMenuDrawerDesktop__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(99650);
/* harmony import */ var _utils_getNavList__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(704956);
/* harmony import */ var src_components_Wishlist_WishlistHeaderMenuItem__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(155039);
/* harmony import */ var src_utils_useCheckIfHomePage__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(576609);






























// import MegaMenuDesktopView from '@/components/MegaMenu/MegaMenuDesktopView';







var Header12 = function(props) {
    var ref, ref1, ref2, ref3;
    var isDesktop = _utils_deviceWidth__WEBPACK_IMPORTED_MODULE_7__/* .deviceWidth */ .o > 786;
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)();
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useDispatch */ .I0)();
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)({
        openShop: false,
        openMore: false,
        openDropdown: false
    }), open = ref5[0], setOpen = ref5[1];
    var ref6 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)({
        desktop: false,
        mobile: false
    }), openMegaMenu = ref6[0], setOpenMegaMenu = ref6[1];
    var ref7 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), setOpenCollections = ref7[1];
    var isHomePage = (0,src_utils_useCheckIfHomePage__WEBPACK_IMPORTED_MODULE_32__/* .useCheckIfHomePage */ .t)();
    var ref8 = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useSelector */ .v9)(function(state) {
        return {
            items: state.cartReducer.items,
            user: state.userReducer
        };
    }), items = ref8.items, user = ref8.user;
    var ref9 = (0,_redux_ssrStore__WEBPACK_IMPORTED_MODULE_25__/* .useSSRSelector */ .kF)(function(state) {
        return {
            storeData: state.storeReducer.store,
            collections: state.catalogReducer.collections,
            navigationList: state.additionalPagesReducer.navigationList
        };
    }), storeData = ref9.storeData, navigationList = ref9.navigationList, collections = ref9.collections;
    var storeLogo = (0,_utils_getActualOrDsStoreLogo__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z)(storeData);
    var navItemsState = (0,_utils_getNavList__WEBPACK_IMPORTED_MODULE_30__/* ["default"] */ .ZP)(navigationList);
    var headerBgColor = (props === null || props === void 0 ? void 0 : (ref = props.config) === null || ref === void 0 ? void 0 : (ref1 = ref.color_scheme) === null || ref1 === void 0 ? void 0 : ref1.bg_color) || "#ffffff";
    var isStoreLogoVisible = (props === null || props === void 0 ? void 0 : (ref2 = props.config) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.hidden_components) === null || ref3 === void 0 ? void 0 : ref3.store_logo_visible) || false;
    var headerRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)();
    var isShopDropDownEnable = (0,_HeaderUtils_useIsShopDropDownEnable__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)();
    (0,_hooks_useSaveHeaderHeight__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)(headerRef);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (!open.openDropdown) setOpenCollections(false);
    }, [
        open.openDropdown
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if ((storeData === null || storeData === void 0 ? void 0 : storeData.store_id) && !navigationList.length) {
            dispatch((0,_redux_actions__WEBPACK_IMPORTED_MODULE_33__/* .getNavigationPagesList */ .A7)({
                storeId: storeData === null || storeData === void 0 ? void 0 : storeData.store_id,
                isPublished: true
            }));
        }
    }, [
        storeData === null || storeData === void 0 ? void 0 : storeData.store_id,
        navigationList
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        document.addEventListener("mousedown", handleClickOutside);
        return function() {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    var handleClickOutside = function(e) {
        if (isDesktop) {
            if (ref4.current && ref4.current.contains(e.target)) {
                return;
            }
            setOpen(function(state) {
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_34__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_35__/* ["default"] */ .Z)({}, state), {
                    openShop: false,
                    openMore: false
                });
            });
        }
    };
    var menuItemClick = function(nav) {
        if ((openMegaMenu === null || openMegaMenu === void 0 ? void 0 : openMegaMenu.desktop) || (openMegaMenu === null || openMegaMenu === void 0 ? void 0 : openMegaMenu.mobile)) {
            setOpenMegaMenu(function() {
                return {
                    desktop: false,
                    mobile: false
                };
            });
        }
        if ((nav === null || nav === void 0 ? void 0 : nav.page_type) === "blank_page" && (nav === null || nav === void 0 ? void 0 : nav.is_external_url)) {
            window.open(nav.slug_url, "_blank");
            return;
        }
        if (nav.slug_url === "shop") {
            if (document.querySelector("#CollectionCategoryProductWidget")) {
                document.querySelector("#CollectionCategoryProductWidget").scrollIntoView();
            } else {
                var ref;
                next_router__WEBPACK_IMPORTED_MODULE_1___default().push((0,_utils_routes__WEBPACK_IMPORTED_MODULE_4__.getRoute)(_utils_routes__WEBPACK_IMPORTED_MODULE_4__.PATH.PRODUCT, storeData === null || storeData === void 0 ? void 0 : (ref = storeData.store_info) === null || ref === void 0 ? void 0 : ref.domain));
            }
        } else if (nav.slug_url === "subNavList") {
            setOpen(function(state) {
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_34__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_35__/* ["default"] */ .Z)({}, state), {
                    openMore: !open.openMore
                });
            });
        } else {
            if (nav.is_editable) {
                var ref1;
                next_router__WEBPACK_IMPORTED_MODULE_1___default().push((0,_utils_routes__WEBPACK_IMPORTED_MODULE_4__.getRoute)(_utils_routes__WEBPACK_IMPORTED_MODULE_4__.PATH.additionalPage(nav.slug_url), storeData === null || storeData === void 0 ? void 0 : (ref1 = storeData.store_info) === null || ref1 === void 0 ? void 0 : ref1.domain));
            } else {
                var ref2;
                next_router__WEBPACK_IMPORTED_MODULE_1___default().push((0,_utils_routes__WEBPACK_IMPORTED_MODULE_4__.getRoute)(nav.slug_url, storeData === null || storeData === void 0 ? void 0 : (ref2 = storeData.store_info) === null || ref2 === void 0 ? void 0 : ref2.domain));
            }
        }
    };
    var navSubList = function(nav) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "cfe-dropdown-nav",
            ref: ref4,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "cfe-dropdown-nav__items",
                children: nav.map(function(n) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "cfe-dropdown-nav__item",
                        onClick: function() {
                            return menuItemClick(n);
                        },
                        children: n.page_name
                    }, n.page_id);
                })
            })
        });
    };
    var handleShopClick = function(page, dropdownNav) {
        if ((0,_utils_showMegaMenu__WEBPACK_IMPORTED_MODULE_11__/* .showMegaMenu */ .G)()) {
            _utils_checkClientDeviceType__WEBPACK_IMPORTED_MODULE_8__/* .IS_DESKTOP */ .yn ? setOpenMegaMenu(function() {
                return {
                    mobile: false,
                    desktop: !openMegaMenu.desktop
                };
            }) : setOpenMegaMenu(function() {
                return {
                    desktop: false,
                    mobile: !openMegaMenu.mobile
                };
            });
        } else {
            if (collections === null || collections === void 0 ? void 0 : collections.length) {
                if (dropdownNav) {
                    setOpenCollections(true);
                    setOpen(function(state) {
                        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_34__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_35__/* ["default"] */ .Z)({}, state), {
                            openShop: !state.openShop
                        });
                    });
                } else {
                    menuItemClick(page);
                }
            } else {
                !dropdownNav && menuItemClick(page);
                open.openShop ? setOpen(function(state) {
                    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_34__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_35__/* ["default"] */ .Z)({}, state), {
                        openShop: false
                    });
                }) : setOpen(function(state) {
                    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_34__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_35__/* ["default"] */ .Z)({}, state), {
                        openShop: true,
                        openMore: false
                    });
                });
            }
        }
    };
    var closeShopDropdown = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function() {
        return setOpen(function(state) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_34__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_35__/* ["default"] */ .Z)({}, state), {
                openShop: false,
                openDropdown: false
            });
        });
    }, []);
    var renderNavType = function(page) {
        var dropdownNav = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        switch(page.slug_url){
            case "":
                var ref, ref1;
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                    className: "menu-item relative tw-select-none",
                    onClick: function() {
                        return menuItemClick(page);
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex items-center justify-between",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex items-center",
                            style: {
                                flex: "1 1 auto"
                            },
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "mr3 visible-mobile",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_assets_svgExports_HeaderHome__WEBPACK_IMPORTED_MODULE_18__/* .HeaderHome */ .Q, {
                                        color: (storeData === null || storeData === void 0 ? void 0 : (ref = storeData.theme) === null || ref === void 0 ? void 0 : (ref1 = ref.colors) === null || ref1 === void 0 ? void 0 : ref1.primary_color) !== "#ffffff" ? "#000000" : "#ffffff"
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CommonNavbarText_CommonNavbarText__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, {
                                    bgColor: headerBgColor,
                                    page: page
                                })
                            ]
                        })
                    })
                }, page.page_id);
            case "shop":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ShopComponent__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                    ref: ref4,
                    page: page,
                    dropdownNav: isShopDropDownEnable,
                    handleShopClick: handleShopClick,
                    setOpenMegaMenu: setOpenMegaMenu,
                    open: open,
                    closeShopDropdown: closeShopDropdown,
                    bgColor: headerBgColor,
                    showMegaMenuDesktop: openMegaMenu.desktop
                });
            case "subNavList":
                var ref2;
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                    className: "menu-item relative tw-select-none",
                    onClick: function() {
                        return menuItemClick(page);
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex items-center justify-between",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "flex items-center",
                                    style: {
                                        flex: "1 1 auto"
                                    },
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CommonNavbarText_CommonNavbarText__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, {
                                        page: {
                                            page_name: "More"
                                        },
                                        bgColor: headerBgColor
                                    })
                                }),
                                (page === null || page === void 0 ? void 0 : (ref2 = page.subNavs) === null || ref2 === void 0 ? void 0 : ref2.length) > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                    className: (0,_utils_invertAngleRightIconColor__WEBPACK_IMPORTED_MODULE_10__/* .invertAngleRightIconColor */ .p)(headerBgColor),
                                    src: "https://cdn.dotpe.in/longtail/themes/8073865/igP6Hh58.webp",
                                    alt: "dropdown button",
                                    style: {
                                        transform: "rotate(90deg)",
                                        width: 7,
                                        marginLeft: dropdownNav ? "0px" : "8px"
                                    }
                                })
                            ]
                        }),
                        open.openMore && navSubList(page.subNavs)
                    ]
                }, page.page_id);
            case "about-us":
                var ref3, ref5;
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                    className: "menu-item relative tw-select-none",
                    onClick: function() {
                        return menuItemClick(page);
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex items-center justify-between",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex items-center",
                            style: {
                                flex: "1 1 auto"
                            },
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "mr3 visible-mobile",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_assets_svgExports_HeaderInfoIcon__WEBPACK_IMPORTED_MODULE_16__/* .HeaderInfoIcon */ .V, {
                                        color: (storeData === null || storeData === void 0 ? void 0 : (ref3 = storeData.theme) === null || ref3 === void 0 ? void 0 : (ref5 = ref3.colors) === null || ref5 === void 0 ? void 0 : ref5.primary_color) !== "#ffffff" ? "#000000" : "#ffffff"
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CommonNavbarText_CommonNavbarText__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, {
                                    bgColor: headerBgColor,
                                    page: page
                                })
                            ]
                        })
                    })
                }, page.page_id);
            default:
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                    className: "menu-item tw-select-none ".concat((0,_utils_getCustomHeaderTextColor__WEBPACK_IMPORTED_MODULE_9__/* .getCustomHeaderTextColor */ .s)(headerBgColor)),
                    onClick: function() {
                        return menuItemClick(page);
                    },
                    children: page.page_name
                }, page.page_id);
        }
    };
    var toggleDropdown = function() {
        setOpen(function(state) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_34__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_35__/* ["default"] */ .Z)({}, state), {
                openDropdown: !state.openDropdown
            });
        });
    };
    var clickForRoute = function(route) {
        var ref;
        next_router__WEBPACK_IMPORTED_MODULE_1___default().push((0,_utils_routes__WEBPACK_IMPORTED_MODULE_4__.getRoute)(route, storeData === null || storeData === void 0 ? void 0 : (ref = storeData.store_info) === null || ref === void 0 ? void 0 : ref.domain));
    };
    var Wrapper = isHomePage ? "h1" : "section";
    var leftSection = function() {
        var ref, ref1, ref2, ref3;
        return isDesktop && ((props === null || props === void 0 ? void 0 : (ref = props.config) === null || ref === void 0 ? void 0 : (ref1 = ref.hidden_components) === null || ref1 === void 0 ? void 0 : ref1.store_logo_visible) || (0,_utils_logoAndNameHelpers__WEBPACK_IMPORTED_MODULE_26__/* .getVisibilityForHeader */ .g)(storeData === null || storeData === void 0 ? void 0 : (ref2 = storeData.theme) === null || ref2 === void 0 ? void 0 : ref2.store_logo_status)) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Wrapper, {
            style: {
                width: "72px",
                alignSelf: "baseline"
            },
            className: "visible-desktop-flex mb5 tw-cursor-pointer",
            onClick: function() {
                return clickForRoute("");
            },
            children: [
                isHomePage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    class: "visually-hidden",
                    children: storeData === null || storeData === void 0 ? void 0 : (ref3 = storeData.store_info) === null || ref3 === void 0 ? void 0 : ref3.name
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    className: storeLogo ? "logo_image_desktop" : "dn",
                    src: storeLogo,
                    alt: "store logo"
                })
            ]
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                    className: "visible-desktop-flex"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "visible-mobile-flex w-100",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Common_ReactHamburger__WEBPACK_IMPORTED_MODULE_5__["default"], {
                        open: open.openDropdown,
                        setOpen: toggleDropdown,
                        theme: (0,_utils_getContrastingColor__WEBPACK_IMPORTED_MODULE_36__/* .getContrastingColor */ .Q)(headerBgColor)
                    })
                })
            ]
        });
    };
    var middleSection = function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_StoreNameComponent__WEBPACK_IMPORTED_MODULE_19__/* .StoreNameComp */ ._, {
            customClass: "visible-desktop justify-center tc"
        });
    };
    var handleCartClick = function() {
        if ((0,_utils_getStoreType__WEBPACK_IMPORTED_MODULE_12__/* .getStoreType */ .K)(storeData) === _utils_constants__WEBPACK_IMPORTED_MODULE_24__/* .STORE_CUSTOMIZATION.B2B */ .DO.B2B) {
            dispatch((0,_redux_actions__WEBPACK_IMPORTED_MODULE_37__/* .toggleRfqFormModal */ .H4)());
            return;
        }
        clickForRoute(_utils_routes__WEBPACK_IMPORTED_MODULE_4__.PATH.CART);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("header", {
        ref: headerRef,
        className: "header12 collection-header tw-font-dmSans",
        style: {
            background: headerBgColor,
            color: (0,_utils_getContrastingColor__WEBPACK_IMPORTED_MODULE_36__/* .getContrastingColor */ .Q)(headerBgColor)
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "header12__top-component",
                children: [
                    leftSection(),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        children: [
                            middleSection(),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "header12__bottom-component visible-desktop-block",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "visible-desktop-flex",
                                    children: (navItemsState === null || navItemsState === void 0 ? void 0 : navItemsState.length) > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                                            className: "header12__bottom-component--menu",
                                            children: [
                                                navItemsState === null || navItemsState === void 0 ? void 0 : navItemsState.map(function(nav) {
                                                    return renderNavType(nav, false);
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                    className: "menu-item",
                                                    style: {
                                                        paddingBottom: 15
                                                    },
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_assets_svgExports_SearchIcon__WEBPACK_IMPORTED_MODULE_17__/* .SearchIcon */ .W, {
                                                        className: "mr3",
                                                        width: "23",
                                                        height: "23",
                                                        color: (0,_utils_getContrastingColor__WEBPACK_IMPORTED_MODULE_36__/* .getContrastingColor */ .Q)(headerBgColor),
                                                        onClick: function() {
                                                            return clickForRoute(_utils_routes__WEBPACK_IMPORTED_MODULE_4__.PATH.SEARCH);
                                                        }
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
                                className: "visible-desktop flex items-center justify-end icon-set",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_Wishlist_WishlistHeaderMenuItem__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z, {
                                            showComponent: "icon",
                                            color: (0,_utils_getContrastingColor__WEBPACK_IMPORTED_MODULE_36__/* .getContrastingColor */ .Q)(headerBgColor),
                                            onClick: function() {
                                                var ref;
                                                next_router__WEBPACK_IMPORTED_MODULE_1___default().push((0,_utils_routes__WEBPACK_IMPORTED_MODULE_4__.getRoute)(_utils_routes__WEBPACK_IMPORTED_MODULE_4__.PATH.WISHLIST, storeData === null || storeData === void 0 ? void 0 : (ref = storeData.store_info) === null || ref === void 0 ? void 0 : ref.domain));
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_LoginAndDropdownComponent__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                            headerBgColor: headerBgColor,
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_assets_svgExports_LoginUserIcon__WEBPACK_IMPORTED_MODULE_14__/* .LoginUserIcon */ .i, {
                                                    width: "23",
                                                    height: "23",
                                                    color: (0,_utils_getContrastingColor__WEBPACK_IMPORTED_MODULE_36__/* .getContrastingColor */ .Q)(headerBgColor)
                                                }),
                                                (user === null || user === void 0 ? void 0 : user.isLogin) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                    alt: "dropdown button",
                                                    src: "/assets/images/down-arrow-thin.svg",
                                                    className: "ml2 arrow-icon ".concat((0,_utils_invertAngleRightIconColor__WEBPACK_IMPORTED_MODULE_10__/* .invertAngleRightIconColor */ .p)(headerBgColor))
                                                }) : ""
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                        onClick: handleCartClick,
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_assets_svgExports_ShoppingBag__WEBPACK_IMPORTED_MODULE_15__/* .ShoppingBag */ .C, {
                                                width: "25",
                                                height: "25",
                                                color: (0,_utils_getContrastingColor__WEBPACK_IMPORTED_MODULE_36__/* .getContrastingColor */ .Q)(headerBgColor)
                                            }),
                                            (items === null || items === void 0 ? void 0 : items.length) > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: "cart-items absolute z-2 ".concat((0,_utils_invertAngleRightIconColor__WEBPACK_IMPORTED_MODULE_10__/* .invertAngleRightIconColor */ .p)(headerBgColor)),
                                                children: items.length
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "visible-mobile",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CommonHeaderIcons__WEBPACK_IMPORTED_MODULE_13__/* .CommonHeaderIconsMobile */ .r, {
                                    color: (0,_utils_getContrastingColor__WEBPACK_IMPORTED_MODULE_36__/* .getContrastingColor */ .Q)(headerBgColor),
                                    headerName: "header12",
                                    isStoreLogoVisible: isStoreLogoVisible
                                })
                            })
                        ]
                    })
                ]
            }),
            openMegaMenu.desktop && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Drawer_MegaMenuDrawerDesktop__WEBPACK_IMPORTED_MODULE_29__/* .MegaMenuDrawerDesktop */ .G, {
                open: openMegaMenu.desktop,
                onClose: function() {
                    return setOpenMegaMenu({
                        desktop: false,
                        mobile: false
                    });
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Drawer_MenuDrawerMobile__WEBPACK_IMPORTED_MODULE_28__/* .MenuDrawerMobile */ .R, {
                isVisible: open.openDropdown,
                closeDrawer: toggleDropdown
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Header12);


/***/ }),

/***/ 155039:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);
/* harmony import */ var _assets_svgExports_WishlistHeartIcon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(407056);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(225617);
/* harmony import */ var _constants_wishlist__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(298627);
/* harmony import */ var src_hooks_useFeatureLocks__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(482516);





var WishlistIcon = function(param) {
    var color = param.color, iconSize = param.iconSize, isActive = param.isActive;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_assets_svgExports_WishlistHeartIcon__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        color: color,
        iconSize: iconSize,
        isActive: isActive
    });
};
var WishlistText = function(param) {
    var _customTextClassName = param.customTextClassName, customTextClassName = _customTextClassName === void 0 ? "" : _customTextClassName, _ctaText = param.ctaText, ctaText = _ctaText === void 0 ? "Wishlist" : _ctaText;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        className: "tw-font-inter tw-text-[17px] tw-font-normal ".concat(customTextClassName),
        children: ctaText
    });
};
var WishlistBoth = function(param) {
    var color = param.color, iconPosition = param.iconPosition, iconSize = param.iconSize, wrapperClassName = param.wrapperClassName, _customTextClassName = param.customTextClassName, customTextClassName = _customTextClassName === void 0 ? "" : _customTextClassName, ctaText = param.ctaText, isActive = param.isActive;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "tw-flex tw-gap-[10px] tw-items-center ".concat(wrapperClassName),
        children: iconPosition === "right" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(WishlistText, {
                    customTextClassName: customTextClassName,
                    ctaText: ctaText
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(WishlistIcon, {
                    color: color,
                    iconSize: iconSize,
                    isActive: isActive
                })
            ]
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(WishlistIcon, {
                    color: color,
                    iconSize: iconSize,
                    isActive: isActive
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(WishlistText, {
                    customTextClassName: customTextClassName,
                    ctaText: ctaText
                })
            ]
        })
    });
};
var WishlistHeaderMenuItem = function(param) {
    var color = param.color, iconSize = param.iconSize, _iconPosition = param.iconPosition, iconPosition = _iconPosition === void 0 ? "right" : _iconPosition, _showComponent = param.showComponent, showComponent = _showComponent === void 0 ? "both" : _showComponent, _customTextClassName = param.customTextClassName, customTextClassName = _customTextClassName === void 0 ? "" : _customTextClassName, _wrapperClassName = param.wrapperClassName, wrapperClassName = _wrapperClassName === void 0 ? "" : _wrapperClassName, ctaText = param.ctaText, isActive = param.isActive, onClick = param.onClick;
    var wishlistFeatureActive = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        var ref, ref1, ref2;
        return {
            wishlistFeatureActive: (ref = state.storeReducer) === null || ref === void 0 ? void 0 : (ref1 = ref.store) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.services) === null || ref2 === void 0 ? void 0 : ref2.wishlist_flag
        };
    }).wishlistFeatureActive;
    var wishlistFeatureStatus = (0,src_hooks_useFeatureLocks__WEBPACK_IMPORTED_MODULE_4__/* .useFeatureLocks */ .r)().wishlistFeatureStatus;
    if (wishlistFeatureActive !== _constants_wishlist__WEBPACK_IMPORTED_MODULE_3__/* .WISHLIST_FEATURE_STATUS.WISHLIST_ACTIVE */ .g.WISHLIST_ACTIVE || (wishlistFeatureStatus === null || wishlistFeatureStatus === void 0 ? void 0 : wishlistFeatureStatus.isLocked)) {
        return null;
    }
    if (showComponent === "icon") return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        onClick: onClick,
        style: {
            cursor: onClick ? "pointer" : undefined
        },
        className: "tw-flex tw-items-center",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(WishlistIcon, {
            color: color,
            iconSize: iconSize,
            isActive: isActive
        })
    });
    if (showComponent === "text") return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        onClick: onClick,
        style: {
            cursor: onClick ? "pointer" : undefined
        },
        className: "tw-flex tw-items-center",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(WishlistText, {
            customTextClassName: customTextClassName,
            ctaText: ctaText
        })
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        onClick: onClick,
        style: {
            cursor: onClick ? "pointer" : undefined
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(WishlistBoth, {
            color: color,
            iconPosition: iconPosition,
            iconSize: iconSize,
            wrapperClassName: wrapperClassName,
            customTextClassName: customTextClassName,
            ctaText: ctaText,
            isActive: isActive
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (WishlistHeaderMenuItem);


/***/ }),

/***/ 636874:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ invertAngleRightIconColor; }
/* harmony export */ });
/* harmony import */ var _getCustomHeaderTextColor__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(956494);

/**
 * invert classes are applied on angle icon based on the headerBgColor
 * @param {*} headerBgColor
 * @return {String} a class based on headerBgColor
 */ function invertAngleRightIconColor(headerBgColor) {
    return (0,_getCustomHeaderTextColor__WEBPACK_IMPORTED_MODULE_0__/* .getCustomHeaderTextColor */ .s)(headerBgColor) === "#ffffff" ? "filter-invert-1" : "filter-invert-0";
}


/***/ })

}]);